/**
 * Central registration file for all custom elements
 * Defines and registers all custom web components used throughout the application
 */

import { VisibilityElement } from './visibility'
import { ModalElement } from './modal'
import { InViewElement } from './in-view'
import { ReadMore } from './read-more'
import { StickyHeader } from './sticky-header'
import { Carousel } from './carousel'
import { StickyBar } from './sticky-bar'
import 'snippets/notice-global/notice-global'
import { ListDisplayElement } from '@/components/custom-elements/list-display'
import { ButtonElement } from './button'
import { CountdownElement } from './countdown'
import { MarqueeElement } from './marquee'
import { TabbedContent } from './tabbed-content'
import { StorageModalElement } from './storage-modal'
import { VerticalCarouselElement } from './vertical-carousel'
import { VideoCustomControlsElement } from './video-custom-controls'
import { MediaZoomElement } from './media-zoom'
import { LottieAnimationElement } from './lottie-animation'

customElements.define('x-visibility', VisibilityElement)
customElements.define('x-modal', ModalElement)
customElements.define('x-in-view', InViewElement)
customElements.define('sticky-header', StickyHeader)
customElements.define('read-more', ReadMore)
customElements.define('x-list-display', ListDisplayElement)
customElements.define('x-carousel', Carousel)
customElements.define('sticky-bar', StickyBar)
customElements.define('x-button', ButtonElement)
customElements.define('x-countdown', CountdownElement)
customElements.define('x-marquee', MarqueeElement)
customElements.define('x-tabbed-content', TabbedContent)
customElements.define('x-storage-modal', StorageModalElement)
customElements.define('x-vertical-carousel', VerticalCarouselElement)
customElements.define('x-video-custom-controls', VideoCustomControlsElement)
customElements.define('x-media-zoom', MediaZoomElement)
customElements.define('x-lottie', LottieAnimationElement)
